<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="推广者编号：" prop="member_code">
                <span>{{model.member_code}}</span>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
                <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="手机号：" prop="cellphone">
                <span>{{model.cellphone}}</span>
            </el-form-item>
            <el-form-item label="批次：" prop="batch">
                <span>{{model.batch}}</span>
            </el-form-item>
            <el-form-item label="结算金额：" prop="money">
                <span>{{model.money}}</span>
            </el-form-item>
            <el-form-item label="结算时间：" prop="settled_time">
                <span>{{model.settled_time}}</span>
            </el-form-item>
            <el-form-item label="操作人：" prop="creator_name">
                <span>{{model.creator_name}}</span>
            </el-form-item>
            <el-form-item label="凭证：" prop="evidence">
                <el-image 
                    style="width: 300px; height: 300px"
                    :src="model.evidence"
                    :preview-src-list="imgList">
                </el-image>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'promotionSettledInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                member_code: '',
                name: '',
                cellphone: '',
                batch: '',
                monty: '',
                settled_time: '',
                creator: '',
                creator_name: '',
                evidence: '',
            },
            getObj:{
                url:'/api/admin/promotionsettled/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            imgList: []
        };
    },
    methods: {
        formateData() {
            this.imgList = [this.model.evidence]
        },
    }
};
</script>